/**
 * Caches storyblok relations resolution
 * @param {object} [initialValue] - initial value to return
 */
const createStoryblokRelationsMemo = (initialValue = null) => {
  let cache = initialValue;
  let key = '';

  return (value) => {
    if (Array.isArray(value)) {
      if (value[0]?.uuid) {
        cache = value;
        key = JSON.stringify(value.map((val) => val.uuid));
        return cache;
      }

      const strValue = JSON.stringify(value);

      if (key === strValue) {
        return cache;
      }

      cache = initialValue;
      key = JSON.stringify(value.map((val) => val.uuid));
      return cache;
    }

    if (value?.uuid) {
      cache = value;
      key = value.uuid;
      return cache;
    }

    if (key === value) {
      return cache;
    }

    cache = initialValue;
    key = value;
    return cache;
  };
};

export default createStoryblokRelationsMemo;
